import { protectWithWorkspacePermissions } from '@routes/-protectWithPermission'
import { withCompanyName } from '@routes/-withCompanyName'
import { createFileRoute, Outlet, useLocation } from '@tanstack/react-router'
import { BotDetectionUpsellView } from 'features/botDetection'
import { MainColumn } from 'features/commonUI'
import { identifyLDSubscription } from 'helpers/launchDarkly'
import { useBotDetectionAccess } from 'hooks/useBotDetectionAccess'
import { canViewAnalyticsPermission } from 'hooks/usePermission'

export const Route = createFileRoute('/_authenticated/_layout/workspaces/$subscriptionId/bot-detection')({
  component: BotDetectionLayout,
  head: () => ({
    meta: [
      {
        title: withCompanyName('Bot Detection'),
      },
    ],
  }),
  beforeLoad: async (ctx) => {
    await protectWithWorkspacePermissions(canViewAnalyticsPermission)(ctx)

    if (ctx.cause !== 'preload') {
      await identifyLDSubscription(ctx.params.subscriptionId, ctx.context.ldClient)
    }
  },
})

function BotDetectionLayout() {
  const { subscriptionId } = Route.useParams()
  const access = useBotDetectionAccess()
  const location = useLocation()
  const isEventsPage = location.pathname.includes('/events')
  if (access.isLoading) {
    return <BotDetectionUpsellView subscriptionId={subscriptionId} isModalOpen={false} />
  }

  if (access.hasAiApiAccess !== true && isEventsPage) {
    return (
      <BotDetectionUpsellView
        subscriptionId={subscriptionId}
        isModalOpen={!access.isLoading && !access.hasAiApiAccess}
      />
    )
  }

  return (
    <MainColumn>
      <Outlet />
    </MainColumn>
  )
}
